














































import {
    defineComponent,
    PropType,
    ref,
    onMounted,
    nextTick,
} from '@vue/composition-api';
import CoreIcon from '@/components/CoreIcon.vue';

interface BaseOption {
    [key: string]: any;
}

export default defineComponent({
    name: 'OptionsPopupDesktop',
    components: { CoreIcon },
    props: {
        options: {
            type: Array as PropType<Array<BaseOption>>,
            required: true,
        },
        selectedOptions: {
            type: Array as PropType<Array<BaseOption>>,
            required: true,
        },
        search: {
            type: Boolean,
            default: false,
        },
        searchQuery: {
            type: String,
            default: '',
        },
        optionClasses: {
            type: Object,
            required: true,
        },
    },
    emits: ['option-select', 'query-change'],
    setup(props, context) {
        const searchInput = ref<HTMLInputElement | null>(null);

        function emitOptionSelectEvent(option: BaseOption) {
            context.emit('option-select', option);
        }

        function handleSearchQueryChange(event: InputEvent) {
            const newSearchQuery = (event.target as HTMLInputElement).value;
            context.emit('query-change', newSearchQuery);
        }

        function isSelected(option: BaseOption) {
            return props.selectedOptions.includes(option);
        }

        onMounted(() => {
            nextTick(() => {
                searchInput.value?.focus();
            });
        });

        return {
            emitOptionSelectEvent,
            handleSearchQueryChange,
            isSelected,
            searchInput,
        };
    },
});
